import { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import BookLogo from "../../Assets/images/books1.png";
import { HiOutlineMenuAlt3 } from "react-icons/hi";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  // navbar functionality
  const handleNavbar = () => {
    setToggleMenu(!toggleMenu);
  };
  return (
    <nav className="navbar" id="navbar">
      <div className="container navbar-content flex">
        <div className="brand-and-toggler flex flex-sb">
          <Link to="/" className="navbar-brand flex">
            <img src={BookLogo} alt="booklogo" width={100} height={100} />
            <span className="uppercase fw-7 fs-24 ls-1">Librium</span>
          </Link>
          <button
            type="button"
            className="navbar-toggler-btn"
            onClick={handleNavbar}
          >
            <HiOutlineMenuAlt3
              size={35}
              style={{
                color: `${toggleMenu ? "#fff" : "#010101"}`,
              }}
            />
          </button>
        </div>

        <div
          className={
            toggleMenu
              ? "navbar-collapse show-navbar-collapse"
              : "navbar-collapse"
          }
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link
                to="book"
                className="nav-link uppercase text-white fs-22 fw-6 ls-1"
              > 
                Books
              </Link>
            </li>
            <li className="nav-item">
              <Link to="about" className="nav-link uppercase text-white  ">
                About
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
